import { useState } from "react";

export const useClientPagination = <T>(data: T[] | undefined, pageSize: number) => {
  const [page, setPage] = useState(0);

  const allItems = data ?? [];
  const totalElements = allItems.length;
  const totalPages = Math.max(1, Math.ceil(totalElements / pageSize));
  const paginatedItems = allItems.slice(page * pageSize, (page + 1) * pageSize);

  return { paginatedItems, totalElements, totalPages, page, setPage };
};
